exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\r\n * Dropdown button styles\r\n */\n.bolt-dropdown-button {\n  display: inline-flex; }\n\n.bolt-dropdown-button .icon-right {\n  font-size: 12px;\n  padding-left: 10px; }\n", ""]);

// exports
